import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_LFD_CONTEXT = createContext();

class PlanItemLFDProvider extends Component {
  state = { lfd_planItems: undefined };

  unsubscribe = null;

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
    .where("state", "==", "l")
    .onSnapshot(snapshot => {
      const containerObjs = snapshot.docs.map(doc => {
        return { id: doc.id, routingContainerState: "l", ...doc.data()};
      });

      let notInvoicedList = containerObjs.filter(function (obj) {
        return obj.invoiced !== true;
      });

      notInvoicedList.sort((a, b) => Helper.compareDateLike(a.lastFreeDay, b.lastFreeDay));

      this.setState({ lfd_planItems : notInvoicedList });
    });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ lfd_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { lfd_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_LFD_CONTEXT.Provider value={lfd_planItems}>{children}</PLANITEM_LFD_CONTEXT.Provider>;
  }
}

export default PlanItemLFDProvider;

PlanItemLFDProvider.defaultProps = {
  branchCode: "NY",
};
